import { Button, Form, Input, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { extractErrorMessage } from '@shared/api';
import { useLoginMutation } from '../api/mutations';

const { Title, Text } = Typography;

interface LoginFormValues {
  email: string;
  password: string;
}

export function LoginForm() {
  const [form] = Form.useForm<LoginFormValues>();
  const loginMutation = useLoginMutation();

  const handleSubmit = async (values: LoginFormValues) => {
    try {
      await loginMutation.mutateAsync(values);
      // Переход делает GuestOnly: вернёт туда, откуда увели на вход, иначе — на Главную.
    } catch {
      // Ошибка показывается ниже формы через mutation.error
    }
  };

  const errorMessage = loginMutation.error ? extractErrorMessage(loginMutation.error) : null;

  return (
    <div>
      <Title level={3} style={{ marginTop: 0, marginBottom: 4 }}>
        Вход в кабинет
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Введите email и пароль
      </Text>

      <Form<LoginFormValues>
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark={false}
        autoComplete="on"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Введите email' },
            { type: 'email', message: 'Некорректный email' },
          ]}
        >
          <Input size="large" type="email" placeholder="user@example.com" autoFocus />
        </Form.Item>

        <Form.Item
          name="password"
          label="Пароль"
          rules={[{ required: true, message: 'Введите пароль' }]}
        >
          <Input.Password size="large" placeholder="••••••••" />
        </Form.Item>

        {errorMessage && (
          <div style={{ marginBottom: 16, color: '#DC2626', fontSize: 13 }}>{errorMessage}</div>
        )}

        <Button
          type="primary"
          htmlType="submit"
          size="large"
          block
          loading={loginMutation.isPending}
        >
          Войти
        </Button>

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Link to="/forgot-password">Забыли пароль?</Link>
          <Link to="/register">Создать аккаунт</Link>
        </div>
      </Form>
    </div>
  );
}
